/* eslint-disable no-alert */ /* eslint-disable no-nested-ternary */
<template>
  <div class="cs-payment">
    <loader ref="loader" />
  </div>
</template>

<script>
import { GET_HOSTED_PAGE_INFO, GET_WHITE_LABEL_INFO } from '@/store/modules/auth/consts';
import { SET_HOSTED_PAGE_INFO } from '@/store/modules/user/consts';

export default {
  name: 'HostedPage',
  async mounted() {
    this.$nextTick(async () => {
      try {
        const hostedPageId = this.$route?.params?.id;
        if (hostedPageId) {
          this.$store.dispatch(`user/${SET_HOSTED_PAGE_INFO}`, hostedPageId);
          const resp = await this.$store.dispatch(`auth/${GET_HOSTED_PAGE_INFO}`, { id: hostedPageId });
          const whitelabelResp = await this.$store.dispatch(`auth/${GET_WHITE_LABEL_INFO}`, resp.returnval);
          this.inheritWhiteLabel(whitelabelResp);
          this.setCartData(resp.returnval);
        } else {
          throw new Error('invalid order!')
        }
      } catch (err) {
        console.log(err)
        this.$router.push({
          name: "404"
        });
      }
    })
  },
  methods: {
    inheritWhiteLabel(data) {
      // check if the iframe was whitelabeled
      if (data.whitelabelStatus != 1) {
        let link = document.querySelector("link[rel~='icon']");
        if (!link) {
          link = document.createElement('link');
          link.rel = 'icon';
          document.getElementsByTagName('head')[0].appendChild(link);
        }
        link.href = data.logo;
      }
    },
    setCartData(data) {
      let rfOrder = {};
      rfOrder = data;
      rfOrder.uuid = this.$route?.params?.id;
      rfOrder.token = data?.customerInfo?.rkflToken;
      rfOrder.merchantAuth = data?.customerInfo?.merchantAuth;
      window.EventBus.emit('rocketfuel_send_cart', rfOrder);
    }
  }
};
</script>

<style lang="scss" scoped></style>
